import { useGlobalContext } from "contexts";
import { useEffect } from "react";

export const useHideNavWhileMounted = () => {
    const globalContext = useGlobalContext();
    useEffect(() => {
        //@ts-ignore
        document.getElementsByTagName("body")[0].style = 'overflow: hidden';
        globalContext.toggleNavVisiblity!(false);
      
        return () => {
            //@ts-ignore
            document.getElementsByTagName("body")[0].style = '';
            globalContext.toggleNavVisiblity!(true);
        };
      }, [globalContext.toggleNavVisiblity]);
};